module.exports = __webpack_public_path__ + "static/media/assessments-active.1e53973d.svg";